import Authorities from '../Authority';
import { AuthorityBankConciliation } from '../Authority/Authority.BankConciliation';
import { AuthorityBill } from '../Authority/Authority.Bill';
import { AuthorityClientArea } from '../Authority/Authority.ClientArea';
import { AuthorityFiscalCoupon } from '../Authority/Authority.FiscalCoupon';
import { AuthorityKits } from '../Authority/Authority.Kits';
import { AuthorityManifestationRecipient } from '../Authority/Authority.ManifestationRecipient';
import { AuthorityMaterial } from '../Authority/Authority.Material';
import { AuthorityQuotation } from '../Authority/Authority.Quotation';
import { AuthorityShedule } from '../Authority/Authority.Schedule';
import { AuthorityVision } from '../Authority/Authority.Vision';
import { AuthorityYardManagement } from '../Authority/Authority.YardManagement';

import { COMBO_PLUS } from './Combo.Plus';

export const COMBO_MASTER = [
  ...COMBO_PLUS,

  ...Object.values(AuthorityKits),
  ...Object.values(AuthorityMaterial),
  ...Object.values(AuthorityQuotation),
  ...Object.values(AuthorityBill),
  ...Object.values(AuthorityShedule),
  ...Object.values(AuthorityFiscalCoupon),
  ...Object.values(AuthorityManifestationRecipient),
  ...Object.values(AuthorityBankConciliation),
  ...Object.values(AuthorityVision),
  ...Object.values(AuthorityYardManagement),
  ...Object.values(AuthorityClientArea),

  // WORKORDER
  Authorities.MOVIMENTATION_WORKORDER_PRINT_QUOTATION_MAP,

  // FISCAL SPED
  Authorities.FISCAL_INVOICE_GENERATE_SPED_FISCAL,
  Authorities.FISCAL_INVOICE_EDIT_SPED_FISCAL,
  Authorities.FISCAL_INVOICE_DELETE_SPED_FISCAL,
  Authorities.FISCAL_INVOICE_ADD_SPED_FISCAL,
  Authorities.FISCAL_INVOICE_VIEW_SPED_FISCAL,
  Authorities.FISCAL_INVOICE_SPED_FISCAL,

  // STONE
  Authorities.STONE_MANAGER,
  Authorities.STONE_DEVICE_CREATE,
  Authorities.STONE_DEVICE_DELETE,
  Authorities.STONE_DEVICE_EDIT,
  Authorities.STONE_ORDER_CREATE,

  // CONFIGURATION USER
  Authorities.CONFIGURATION_USER_ACCOUNT_AMAZON,

  //LINK EMPLOYEE YARD MANAGEMENT
  Authorities.ENABLE_EMPLOYEE_ACCESS_IN_YARD_MANAGEMENT,
];
